import _ from 'lodash';
import React from 'react';
import { useRouter } from 'next/router';

import { buildContentMatrixQuery, fetch } from '@/utils/api';
import { CACHE, SECTION_HANDLES, URLS } from '@/constants';
import { transformContentMatrix } from '@/utils/transform';
import ContentMatrix from '@/components/content-matrix';
import Layout from '@/components/layout';
import PageHeaderMatrix from '@/components/page-header-matrix';
import VehiclesWithSafetyFeature from '@/components/vehicles-with-safety-feature';
import ErrorPage from '@/pages/_error';
import logger from '@/utils/logger';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'contentMatrices' implicitly has an 'any' type.
const SafetyFeature = ({ contentMatrices, removeFromCompare, safetyFeature, slug }) => {
  const router = useRouter();
  if ((!router.isFallback && !safetyFeature?.slug) || !safetyFeature) {
    logger.error(
      'Error when loading safety feature',
      { router, safetyFeature, slug },
      {
        route: router.pathname,
      }
    );
    return <ErrorPage statusCode={404} />;
  }

  let { contentMatrix, pageHeaderMatrix } = contentMatrices;
  contentMatrix = transformContentMatrix(contentMatrix);
  pageHeaderMatrix = transformContentMatrix(pageHeaderMatrix);

  const pageTitle = safetyFeature.title;
  const breadcrumbs = {
    title: pageTitle,
    ancestors: [{ title: 'Safety features', url: URLS.SAFETY_FEATURES_LISTING }],
  };

  return (
    <Layout isHomePage={false} {...{ removeFromCompare }}>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'elementMapping' is missing in type '{ blocks: any; breadcrumbs: { title: any; ancestors: { title: string; url: string; }[]; }; }' but required in type 'PageHeaderMatrixProps'. */}
      <PageHeaderMatrix blocks={pageHeaderMatrix} breadcrumbs={breadcrumbs} />
      <ContentMatrix blocks={contentMatrix} />
      <VehiclesWithSafetyFeature {...{ safetyFeature }} />
    </Layout>
  );
};

async function getStaticPaths() {
  const query = `
  query($section: [String]){
    entries(section: $section) {
      ... on tacSafetyFeatures_tacSafetyFeatures_Entry {
        slug
      }
    }
  }
  `;

  const variables = { section: SECTION_HANDLES.TAC_SAFETY_FEATURES };

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
  const data = await fetch({
    method: 'post',
    query,
    variables,
  });

  const entries = _.get(data, 'data.entries', []);

  return {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'slug' implicitly has an 'any' type.
    paths: (entries || []).map(({ slug }) => ({
      params: { safetyFeature: slug },
    })),
    fallback: 'blocking',
  };
}

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'params' implicitly has an 'any' type.
const getStaticProps = withAppProps(async ({ params, preview, previewData }) => {
  const { safetyFeature: safetyFeatureSlug } = params;
  const safetyFeaturesQuery = `{
    entries(slug: "${safetyFeatureSlug}") {
      title
      slug
      ... on tacSafetyFeatures_tacSafetyFeatures_Entry {
        tacFeatureCode
        featureDescription
      }
    }
  }`;

  const safetyFeaturesResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: safetyFeaturesQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );
  const contentMatrixQuery = buildContentMatrixQuery({
    section: SECTION_HANDLES.TAC_SAFETY_FEATURES,
    slug: safetyFeatureSlug,
  });
  const contentMatrixResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: contentMatrixQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  return {
    props: {
      slug: safetyFeatureSlug,
      safetyFeature: _.first(safetyFeaturesResponse.data.data.entries),
      contentMatrices: _.first(contentMatrixResponse.data.data.entries),
    },
    revalidate: CACHE.REVALIDATE,
  };
});

export default withAppProviders(SafetyFeature);
export { getStaticProps, getStaticPaths };
